import {
  type FeatureFlagsConfig,
  isFeatureFlagEnabled,
} from './is-feature-flag-enabled.js';
import {validateFeatureFlagsConfig} from './validate-feature-flags-config.js';

declare global {
  var smart_featureFlags: FeatureFlagsConfig | undefined;
}

// setGlobalFeatureFlags has to be called before React is rendered, to avoid any issue with
// rendering cycles. It is safe to consider feature flags would not change during the lifetime
// of a visitor session.
export const setGlobalFeatureFlags = (
  featureFlags: FeatureFlagsConfig,
): void => {
  globalThis.smart_featureFlags = featureFlags;
};

// getGlobalFeatureFlags likely rarely used, in favor of isGlobalFeatureFlagsEnabled
export const getGlobalFeatureFlags = (): FeatureFlagsConfig | undefined => {
  return globalThis.smart_featureFlags;
};

// isGlobalFeatureFlagsEnabled checks against the global featureFlag.
export const isGlobalFeatureFlagsEnabled = (
  featureFlagName: string,
  market?: string,
): boolean => {
  const featureFlags = getGlobalFeatureFlags();
  if (!featureFlags) {
    console.error(`featureFlags are not set in globalThis.`);
  }

  return isFeatureFlagEnabled(featureFlagName, market || ``, featureFlags);
};

// validateGlobalFeatureFlagsConfig checks against the global featureFlag.
export const validateGlobalFeatureFlagsConfig = (
  usedFeatureFlags: string[],
): FeatureFlagsConfig => {
  const featureFlags = getGlobalFeatureFlags();
  if (!featureFlags) {
    throw Error(`featureFlags are not set in globalThis.`);
  }
  return validateFeatureFlagsConfig(featureFlags, usedFeatureFlags);
};
